import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useUrlChangeHandler } from '../../hooks/useUrlChangeHandler';
import BrowseFilter from '../../components/cards/filter/BrowseFilter';
import BrowseCard from '../../components/cards/card/BrowseCard';
import CardsContainer from '../../components/cards/CardsContainer';

const BrowsePage = () => {
  const location = useLocation();
  const mountedRef = useRef(false);
  const { 
    products, 
    loading, 
    dataLoading, 
    error, 
    hasMore, 
    totalResults, 
    searchTerm,
    isInitialized,
    lastSearch 
  } = useSelector(state => state.filter);
  
  // Handle URL changes
  useUrlChangeHandler();

  // Handle component lifecycle
  useEffect(() => {
    
    if (!mountedRef.current) {
      mountedRef.current = true;
    }
    
    return () => {
      if (mountedRef.current) {
        mountedRef.current = false;
      }
    };
  }, []);

  // Determine if we should show loading state
  const showLoading = loading || (!isInitialized && !lastSearch);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col gap-6">
          {/* Filter Section - always full width */}
          <div className="w-full">
            <div className="bg-white shadow-sm rounded-lg">
              <BrowseFilter />
            </div>
          </div>
          
          {/* Cards Section - always full width */}
          <div className="w-full">
            <div className="bg-white shadow-sm rounded-lg p-6">
              <CardsContainer
                loading={showLoading}
                error={error}
                hasMore={hasMore}
                totalResults={totalResults}
                searchTerm={searchTerm}
                dataLoading={dataLoading}
                isInitialized={isInitialized}
                lastSearch={lastSearch}
              >
                {products.map(product => (
                  <BrowseCard 
                    key={product.id} 
                    product={product}
                  />
                ))}
              </CardsContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowsePage; 